import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { parse } from 'papaparse';
import axios from 'axios';
import styles from './createcsv.module.scss';
import cx from "classnames";
const API_URL = process.env.REACT_APP_API_URL;
const USERS_BASE_URL = `${API_URL}/api/1.0/users`;

const CSVReader = () => {
const account = useSelector((state) => state.accounts.account);

const [users, setUsers] = useState([]);

  const [total, setTotal] = useState(0);
  const [uploaded, setUploaded] = useState(0);
  const [failed, setFailed] = useState(0);
  const [processingUser, setProcessingUser] = useState(null);

  const [processing, setProcessing] = useState(false);
  const required_fields = ['firstName', 'lastName', 'email', 'mobilePhone', 'password', 'role']

  useEffect(() => {
    setUsers([]);
    setTotal(0);
    setUploaded(0);
    setFailed(0);
    setProcessingUser(null);
    setProcessing(false);
  }, []);
  useEffect(async () => {

    if (users !== null && users !== undefined) {
      for (let i = 0; i < users.length; i++) {
        await createUser(users[i]);
      }

      setProcessingUser(false);
      setTimeout(() => {
        setProcessing(false);
      }, 2000);
    }

  }, [users]);

  useEffect(() => {

    if (processing === false) {
      setTotal(0);
      setUploaded(0);
      setFailed(0);
    }

  }, [processing])

  useEffect(() => {
   
    if (total > 0 && (uploaded + failed === total) ) {
     
      toast.info(`Total users ${total}, Uploaded ${uploaded}, Failed ${failed}`);

    }
    
  }, [total, uploaded, failed]);

  const createUser = async (user) => {
    try {

      if (user.email === null || user.email === undefined) {
        toast.error('failed to create user email not found')
        setFailed(prev => prev + 1);
        return;
      }

      setProcessingUser(user);

      await axios({
        method: 'POST',
        url: USERS_BASE_URL,
        data: user,
        params: { accountId: account.id },


      }

      );
      setUploaded(prev => prev + 1);

    } catch (err) {

      if (err && !_.isEmpty(err.errors)) {
        let errors = err.errors;
        let error = errors[0];

        if (error.field !== null && error.field !== undefined) {
          toast.error(`${user.email} ${error.field} ${error.message}`)
        } else {
          toast.error(`${error.message}`)
          
        }
      }
      setFailed(prev => prev + 1);
    }
  }


  const _handleCSVImport = (e) => {
    parse(e.target.files[0], {
      header: true,
      complete: (results) => {

        let fields = results.meta.fields;

        let missingColumns = [];
        for (let i = 0; i < required_fields.length; i++) {
          let field = required_fields[i];
          let index = fields.indexOf(field);
          if (index === -1) {
            missingColumns.push(field);
          }
        }

        if (missingColumns.length > 0) {
          toast.error(`Missing columns: ${missingColumns.join(', ')}`);
          return;
        }

        setProcessing(true);
        const users = results.data;

        setTotal(users.length);
        setUsers(users);

      }
    });

  }
  return (
    <div>
      <div className={styles.buttonMove}>
        <div>
          <label className={styles.inviteButton} htmlFor="csvInput">
            Upload Users</label>
          <i className={cx("upload icon", styles.uploadFileicon)}></i>
        </div>
        <input
          type="file"
          accept=".csv"
          className={styles.fileUploadInput}
          onChange={_handleCSVImport}
        />
      </div>
      <div>{processingUser && <span className={styles.creatingUser}>creating user {processingUser.email}...</span>} </div>
    </div>
  );
};

export default CSVReader;

